import axios from '@/axios.js'

export default {
  fetchRatePlans ({ commit }, hotelId) {
    return new Promise((resolve, reject) => {
      axios.get(`hotels/${hotelId}/rate-plans`)
        .then(({data: response}) => {
          commit('SET_RATE_PLANS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchRatePlan (context, { hotelId, ratePlanId }) {
    return new Promise((resolve, reject) => {
      axios.get(`hotels/${hotelId}/rate-plans/${ratePlanId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  storeRatePlan (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`vancynet/rate-plan`, payload)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  updateRatePlan (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`vancynet/rate-plan/${payload.id}`, payload.body)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  destroyRatePlan ({ commit }, { hotelId, ratePlanId }) {
    return new Promise((resolve, reject) => {
      axios.delete(`hotels/${hotelId}/rate-plans/${ratePlanId}`)
        .then((response) => {
          commit('REMOVE_RECORD',ratePlanId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
